import * as Yup from "yup";
const NewsvalidationSchema = Yup.object({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  category: Yup.string().required("Category is required"),
  contentType: Yup.string().required("Content Type is required"),
  contentUrl: Yup.string()
    .url("Enter a valid URL")
    .required("Content URL is required"),
  linkUrl: Yup.string()
    .url("Enter a valid URL")
    .required("Link URL is required"),
  additionalText: Yup.string().required("Additional Text is required"),
  universityId: Yup.string().required("University ID is required"),
  universityName: Yup.string().required("University Name is required"),
  displayOrder: Yup.string().required("Display Order is required"),
  active: Yup.string().required("Active is required"),
});

export default NewsvalidationSchema;
